import { render, staticRenderFns } from "./JobDesc.vue?vue&type=template&id=89c203b6"
import script from "./JobDesc.vue?vue&type=script&lang=js"
export * from "./JobDesc.vue?vue&type=script&lang=js"
import style0 from "./JobDesc.vue?vue&type=style&index=0&id=89c203b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports